import { render, staticRenderFns } from "./VuesticIconFaster.vue?vue&type=template&id=28df0741&"
import script from "./VuesticIconFaster.vue?vue&type=script&lang=js&"
export * from "./VuesticIconFaster.vue?vue&type=script&lang=js&"
import style0 from "./VuesticIconFaster.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticIconFaster.vue"
export default component.exports